import { FC } from "react";
import { IconProps } from "./types";

export const SocialYoutubeCircle: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.172 8.632c.31.313.483.737.481 1.178.055.73.074 1.461.076 2.19.003.73-.021 1.461-.076 2.192a1.662 1.662 0 0 1-1.655 1.67c-1.305.054-2.638.08-3.998.077a88.708 88.708 0 0 1-4-.077 1.663 1.663 0 0 1-1.654-1.67c-.055-.73-.076-1.46-.076-2.191 0-.73.021-1.46.076-2.191A1.663 1.663 0 0 1 8 8.14c1.306-.055 2.639-.081 3.999-.08a88.057 88.057 0 0 1 3.998.08c.441.001.863.179 1.174.492zm-6.605.861v5.014L14.15 12l-3.582-2.507z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zm-1.5 0c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12z"
      fill={fill}
    />
  </svg>
);
